import { useState, useMemo, useEffect } from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiBadgeDot from "components/SuiBadgeDot";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import config from "configs";
import { Users } from "api";

var TITLE = "Users";

var columns;

function UserList({mode}) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  TITLE = t("Users");
  columns = [
    { Header: t("Name"), accessor: "name", width: "20%" },
    { Header: t("Area Code"), accessor: "areaCode", width: "20%" },
    { Header: t("Mobile Number"), accessor: "mobile" },
    { Header: t("User Type"), accessor: "userType",
      Cell: ({value}) => {
        
        let color = "dark";
        let bgColor = "light"

        if (value === "Live")
        {
          color = "light";
          bgColor = "#344767";
        }
        else if (value === "Demo")
        {
          color = "light";
          bgColor = "#0bbee7";
        }
        else
        {
          color = "dark";
          bgColor = "light"
        }

        // let color = "white";
        // let bgColor = "dark"
        // let color = "dark";
        // let bgColor = "secondary"
        return (
          <SuiBox ml={-1.325} p={1} style={{
            // background: 'red'
          }}
          bgColor={bgColor}
          color={color}
          borderRadius={10}
          >
            {/* <SuiBadgeDot size="xs" color={color} badgeContent={t(value)} /> */}
            
              {t(value)}
            
            
          </SuiBox>
        );
      }
    },  
    {
      Header: t("Status"),
      accessor: "status",
      width: "15%",
      Cell: ({ value }) => {
        let color = "success";
        if (value === "inactive") {
          color = "dark";
        }
        return (
          <SuiBox ml={-1.325}>
            <SuiBadgeDot size="xs" color={color} badgeContent={t(value)} />
          </SuiBox>
        );
      },
    },
  ];
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const [rawData, setRawData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const tableData = useMemo(() => {
    const data = { columns, rows: [] };

    data.rows = [];
    _.get(rawData, "results", []).forEach((result) => {
      data.rows.push({
        id: result.id,        
        userType: result.userType,  
        areaCode: result.areaCode,
        mobile: result.mobile,
        name: result.name,
        status: result.status,
        style: {
          cursor: 'pointer'
        },
      });
    });

    return data;
  }, [rawData]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const params = { page, pageSize: config.defaults.PAGE_SIZE };
        if (search) {
          params['keyword'] = search;
        }
        if (activeTab === 1) {
          params.status = "active";
        } else if (activeTab === 2) {
          params.status = "inactive";
        }
        const rsp = await Users.getAll(params);
        const { data } = rsp;
        setRawData(data);

        const { total, pageSize } = data;
        setPageCount(Math.ceil(total / pageSize));
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    })();
  }, [page, search, activeTab]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5} width="100%">
          <SuiBox width="100%">
            <Card>
              <SuiBox p={3} lineHeight={1}>
                <SuiBox display="flex" justifyContent="space-between" alignItems="center" pt={2}>
                  {mode!=="view" && (
                  <SuiButton
                    variant="gradient"
                    color="info"
                    onClick={() => {
                      history.push(`/users/new`);
                    }}
                  >
                    {t("ADD USER")}
                  </SuiButton>
                  )}
                  {mode === "view" && <span />}
                  <SuiBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="50%"
                  >
                    <SuiBox width="100%">
                      <AppBar position="static">
                        <Tabs
                          orientation="horizontal"
                          value={activeTab}
                          onChange={(...args) => {
                            setActiveTab(args[1]);
                          }}
                        >
                          <Tab label={t("All")} style={{ padding: 10 }} />
                          <Tab label={t("Active")} />
                          <Tab label={t("Inactive")} />
                        </Tabs>
                      </AppBar>
                    </SuiBox>
                  </SuiBox>
                  <SuiBox />
                </SuiBox>
              </SuiBox>

              {isLoading ? (
                // Loading placeholder
                <SuiBox p={3}>Loading...</SuiBox>
              ) : (
                <DataTable
                  pageCount={pageCount}
                  table={tableData}
                  showTotalEntries={false}
                  entriesPerPage={false}
                  isSorted={true}
                  canSearch
                  onSearch={setSearch}
                  defaultGlobalFilter={search}
                  onRowClick={(row) => {
                    history.push(`/users/edit/${row.original.id}`);
                  }}
                  onPageChange={setPage}
                  page={page}
                />
              )}
            </Card>
          </SuiBox>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default UserList;